import { render, staticRenderFns } from "./TrainingSwiper.vue?vue&type=template&id=f646ed5e&scoped=true"
import script from "./TrainingSwiper.vue?vue&type=script&lang=js"
export * from "./TrainingSwiper.vue?vue&type=script&lang=js"
import style0 from "./TrainingSwiper.vue?vue&type=style&index=0&id=f646ed5e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f646ed5e",
  null
  
)

export default component.exports